import { JSX } from 'react'

import { PageLayout } from '~/components/component-library'
import { EmptyState } from '~/components/component-library/EmptyState'
import { IAddress } from '~/types'

export const AccountNotFoundPage = ({
  address,
}: {
  address: IAddress | undefined
}): JSX.Element => {
  return (
    <PageLayout>
      <EmptyState title={<h1>Account not found on Splits</h1>}>
        <p>This account is not a smart account on Splits.</p>
        <p>
          If you believe this is an error, please email{' '}
          <span className="font-medium">support@splits.org</span> with the
          following information:
        </p>
        <div>
          <div>
            <span className="font-semibold">Address:</span>
            &nbsp;{address}
          </div>
        </div>
      </EmptyState>
    </PageLayout>
  )
}
